"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
var _default = ownerDocument;
exports.default = _default;